import React from 'react';
import cx from 'classnames';
import styles from './Paragraph.module.scss';

export interface ParagraphProps extends UI.Text {
	size?: 'md' | 'lg';
	strong?: boolean;
	role?: string;
	ariaLevel?: number;
}

export const Paragraph: React.FC<ParagraphProps> = ({ children, className, size, strong, role, ariaLevel }) => (
	<p
		className={cx(styles.Paragraph, className, styles[`Paragraph___${size}`], {
			[styles.Paragraph___strong]: strong,
		})}
		{...(role ? { role } : {})}
		{...(ariaLevel !== undefined ? { 'aria-level': ariaLevel } : {})}
	>
		{children}
	</p>
);
